import type { AgentFile } from '../types';
import { api } from './apiClient';

// Arquivos RAG do agente. A lista é autoritativa no backend (tabela agent_files);
// o componente não guarda mais isso em agent.files.
export const agentFilesService = {
  async list(agentId: string): Promise<AgentFile[]> {
    const res = await api.get<{ files: AgentFile[] }>(`/agents/${encodeURIComponent(agentId)}/files`);
    return res.files;
  },

  async upload(agentId: string, files: File[], embeddingModel: string): Promise<AgentFile[]> {
    const form = new FormData();
    form.append('embeddingModel', embeddingModel);
    files.forEach((f) => form.append('files', f));
    const res = await api.upload<{ files: AgentFile[] }>(`/agents/${encodeURIComponent(agentId)}/files`, form);
    return res.files;
  },

  async remove(agentId: string, fileId: string): Promise<void> {
    await api.del(`/agents/${encodeURIComponent(agentId)}/files/${encodeURIComponent(fileId)}`);
  },

  async reindex(agentId: string, fileId: string): Promise<void> {
    await api.post(`/agents/${encodeURIComponent(agentId)}/files/${encodeURIComponent(fileId)}/reindex`);
  },
};
